import { ICase } from "dto/Cases/ICase";
import { ICaseSimple } from "dto/Cases/ICaseSimple";
import { IRegistryInvoicePrefill } from "dto/Invoices/IRegistryInvoicePrefill";
import { IRegistryInvoice } from "dto/Invoices/IRegistryInvoice";
import { createContext } from "react";

export interface IModalsManager {
  createDossier: boolean;
  createCase: boolean;
  createAction: boolean;
  createTask: boolean;
  createEvent: boolean;
  createEntity: boolean;
  createCompany: boolean;
  createLetter: boolean;
  createPostage: boolean;
  /** Edycja zarejestrowanej przesyłki przychodzącej (kreator biura podawczego w trybie edycji). */
  editIncomingParcel: boolean;
  createPost: boolean;
  hide: boolean;
  settings: boolean;
  attachCase: boolean;
  editLabels: boolean;
  editStatus: boolean;
  addAddress: boolean;
  addClient: boolean;
  editPDFName: boolean;
  initialConfig: boolean;
  createHelpdesk: boolean;
  createChat: boolean;
  createInvoice: boolean;
  internalPass: boolean;
  decree: boolean;
  generateLetters: boolean;
  dispatch: boolean;
  /** Potwierdzenie odbioru osobistego przesyłki przychodzącej (biuro podawcze). */
  confirmPickup: boolean;
  /** Rejestracja zwrotki ZPO / odbioru dla wysłanej przesyłki (per-przesyłka). */
  registerReception: boolean;
  menu: boolean;
  createMobile: boolean;
  contactFormSettings: boolean;
  recoveryCode: boolean;
  createBudgetExpense: boolean;
  createBudgetEngagement: boolean;
  createContractEntry: boolean;
  createInvoiceRegistryEntry: boolean;
}

type IModalsManagerContext = {
  modals: IModalsManager;
  options: IModalOptions;
  setModals: (modals: IModalsManager) => void;
  setOptions: (options: IModalOptions) => void;
};

export const defaultValue = {
  createDossier: false,
  createCase: false,
  createAction: false,
  createTask: false,
  createEvent: false,
  createEntity: false,
  createCompany: false,
  createLetter: false,
  createPostage: false,
  editIncomingParcel: false,
  createPost: false,
  settings: false,
  attachCase: false,
  editLabels: false,
  editStatus: false,
  addAddress: false,
  addClient: false,
  editPDFName: false,
  initialConfig: false,
  hide: false,
  createHelpdesk: false,
  createChat: false,
  internalPass: false,
  decree: false,
  generateLetters: false,
  dispatch: false,
  confirmPickup: false,
  registerReception: false,
  menu: false,
  createMobile: false,
  createInvoice: false,
  contactFormSettings: false,
  recoveryCode: false,
  createBudgetExpense: false,
  createBudgetEngagement: false,
  createContractEntry: false,
  createInvoiceRegistryEntry: false,
};

export interface IModalOptions {}

export class ContractRegistryModalOptions implements IModalOptions {
  file?: Blob | null;
  fileName?: string;
}

export class InvoiceRegistryModalOptions implements IModalOptions {
  file?: Blob | null;
  fileName?: string;
  /** Tryb „Księgowanie" z faktury KSeF: ukrywa sekcję pliku i wypełnia pola. */
  accountingMode?: boolean;
  /** Dane do wstępnego wypełnienia (z faktury KSeF) w trybie „Księgowanie". */
  prefill?: IRegistryInvoicePrefill;
  /** Faktura źródłowa — do podglądu PDF w trybie „Księgowanie". */
  invoice?: IRegistryInvoice;
  /** Przejście do księgowania następnej faktury z rejestru (tryb „Księgowanie"). */
  onBookNext?: () => void;
  /** Oznaczenie bieżącej faktury jako zaksięgowanej (do pomijania w kolejce). */
  onBooked?: () => void;
}

export class IncomingParcelEditModalOptions implements IModalOptions {
  /** Id edytowanej przesyłki przychodzącej (ItemKind.Parcel). */
  editParcelId?: string;
}

export class BudgetEngagementModalOptions implements IModalOptions {
  initialExpenseId?: string;
}

export class LetterModalOptions implements IModalOptions {
  format?: string;
  callback?: () => void;
}

export class CaseModalOptions implements IModalOptions {
  item?: ICaseSimple;
}

export class ClientModalOptions implements IModalOptions {
  ClientId: number;
}

export class CreateOutgoingParcelModalOptions implements IModalOptions {
  case?: ICase;
}

const ModalsManagerContext = createContext<IModalsManagerContext>({
  modals: defaultValue,
  options: {} as IModalOptions,
  setModals: () => {},
  setOptions: () => {},
});

export default ModalsManagerContext;
